// Once Tagvenue is installed as an app, the system shows the app's icon next to its notifications, so the service
// worker leaves out the logo it adds in a browser. Only a page can tell it's the app, so it leaves this note in the
// browser's storage for public/web-push-sw.js, which reads the same entry
const NOTE_CACHE = 'tgv-web-push';
const NOTE_URL = '/venue-cabinet/web-push/installed-app';

const leaveNote = async () => {
  try {
    await (await caches.open(NOTE_CACHE)).put(NOTE_URL, new Response('1'));
  } catch {
    // no storage, e.g. private browsing: the logo just shows twice
  }
};

const removeNote = async () => {
  try {
    await (await caches.open(NOTE_CACHE)).delete(NOTE_URL);
  } catch {
    // no storage: there's no note either
  }
};

// In a Chrome tab, Chrome says whether the app is installed, as public/site.webmanifest lists it as related to itself.
// That also catches an app installed from Chrome's menu, and one that was removed. Other browsers can't tell, so the
// note stays as it is there
const checkInstalledApp = async () => {
  if (!('getInstalledRelatedApps' in navigator)) {
    return;
  }

  try {
    const apps = await navigator.getInstalledRelatedApps();
    await (apps.some(app => app.platform === 'webapp') ? leaveNote() : removeNote());
  } catch {
    // Chrome couldn't say: the note stays as it is
  }
};

let isListening = false;

export default function rememberHomeScreenApp() {
  if (!('caches' in window) || isListening) {
    return;
  }

  isListening = true;
  if (window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches) {
    leaveNote();
  } else {
    checkInstalledApp();
  }
  window.addEventListener('appinstalled', leaveNote);
}
